export default __webpack_public_path__ + "static/media/logoWithoutName.55c108ba.png";